<template>
 <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="changeName($event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.slug"
            :external-errors="errors['slug']"
            :label-form="'Slug' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.slug"
            :disabled="!formEditable"
            @change="$set(form, 'slug', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-checkbox
            :validator="$v.form.is_invoice_address"
            :external-errors="errors['is_invoice_address']"
            :label-form="'Invoice address' | translate"
            class-form="col-4 mb-2"
            label-cols-lg="4"
            label-cols-sm="4"
            :value="form.is_invoice_address"
            :disabled="!formEditable"
            @change="$set(form, 'is_invoice_address', $event)"
          />
          <form-thux-horizontal-checkbox
            :validator="$v.form.is_shipping_address"
            :external-errors="errors['is_shipping_address']"
            :label-form="'Shipping address' | translate"
            class-form="col-4 mb-2"
            label-cols-lg="4"
            label-cols-sm="4"
            :value="form.is_shipping_address"
            :disabled="!formEditable"
            @change="$set(form, 'is_shipping_address', $event)"
          />
          <form-thux-horizontal-checkbox
            :validator="$v.form.is_registered_office"
            :external-errors="errors['is_registered_office']"
            :label-form="'Registered office' | translate"
            class-form="col-4 mb-2"
            label-cols-lg="4"
            label-cols-sm="4"
            :value="form.is_registered_office"
            :disabled="!formEditable"
            @change="$set(form, 'is_registered_office', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as ADDRESS_SCOPE_TYPES } from './store'

import slugify from 'slugify'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'AddressScopeEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Address scope',
      rolePerm: 'address_addressscope_retrieve',
      editRolePerm: 'address_addressscope_update'
    }
  },
  computed: {
    ...mapGetters({
      ...ADDRESS_SCOPE_TYPES.GENERIC.address.addressscope.DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...ADDRESS_SCOPE_TYPES.GENERIC.address.addressscope.DETAIL.ACTIONS
    }),
    changeName (evt) {
      this.$set(this.form, 'name', evt)
      if (this.formEditable) {
        this.setSlug()
      }
    },
    setSlug () {
      this.$v.form.name.$touch()
      if (this.form.name) {
        this.$set(this.form, 'slug', slugify(this.form.name, { remove: /[*+~.()'"!:@]/g }))
      } else {
        this.$set(this.form, 'slug', undefined)
      }
    }
  },
  validations: {
    form: {
      name: { required },
      slug: { required },
      is_invoice_address: {},
      is_shipping_address: {},
      is_registered_office: {}
    }
  }
}
</script>
